import { useEffect, useState } from 'react';
import { List, Button, Card, Modal, message, Spin, Typography } from 'antd';
import PCCCreate from './PCCCreate';
import { useAuth } from '../../components/AuthProvider';
import { fetchUserPCC } from "../../apis/pccApi";
import PCCComments from './PCCComments';

const { Text } = Typography;

const MyPCC = () => {
  const [pccs, setPccs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const { authenticatedUser } = useAuth();
  const [openCommentsPqrId, setOpenCommentsPqrId] = useState(null);

  const fetchPCCs = async () => {
    try {
      setLoading(true);
      const response = await fetchUserPCC(authenticatedUser);
      setPccs(response.data);
    } catch (err) {
      message.error('Error al cargar tus PQRs, contacta a soporte');
    } finally {
      setLoading(false);
    }
  };

  const handleNewPCC = () => {
    setShowForm(true);
  };

  const handleFormSuccess = () => {
    setShowForm(false);
    fetchPCCs();
  };

  const toggleComments = (pqrId) => {
    setOpenCommentsPqrId((prevId) => (prevId === pqrId ? null : pqrId));
  };

  useEffect(() => {
    fetchPCCs();
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: '2rem auto' }}>
      <Card
        title="Mis PQRs"
        extra={<Button type="primary" onClick={handleNewPCC}>Nuevo PQR</Button>}
      >
        {loading ? (
          <Spin />
        ) : (
          <List
            bordered
            dataSource={pccs}
            renderItem={(item) => (
              <List.Item key={item.id} style={{ display: 'block' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <Text strong>PQR #{item.id}</Text>
                    <p>
                    {item.status === 4 && (
                        <Text type="warning">Esperando tu respuesta</Text>
                    )}
                    </p>
                  </div>
                  <Button type="link" onClick={() => toggleComments(item.id)}>
                    {openCommentsPqrId === item.id ? 'Ocultar comentarios' : 'Ver comentarios'}
                  </Button>
                </div>

                {openCommentsPqrId === item.id && (
                  <div style={{ marginTop: 16 }}>
                    <PCCComments pqrId={item.id} />
                  </div>
                )}
              </List.Item>
            )}
            locale={{ emptyText: 'No tienes PQRs abiertos' }}
          />
        )}

        { /* TODO: permitir que el usuario cierre o cancele el PQR
          TODO: cuando el usuario coloque un nuevo comentario quitar el mensaje de necesita respuesta
        */}
      </Card>

      <Modal
        title="Crear nuevo PQR"
        open={showForm}
        footer={null}
        onCancel={() => setShowForm(false)}
        destroyOnClose
      >
        <PCCCreate onSuccess={handleFormSuccess} />
      </Modal>
    </div>
  );
};

export default MyPCC;
